import { GET_CLINIC_LIST_SUCCESS, GET_CLINIC_LIST_ERROR } from "../actions";

const initialFilterOptions = {
   filterByType: null,
   filterByArea: null
};

const initialState = {
   data: [],
   typeList: [],
   zoneList: [],
   areaList: [],
   isLoaded: false,
   filterOptions: initialFilterOptions,
   error: null
};

export default function(state = initialState, action) {
   switch (action.type) {
      case GET_CLINIC_LIST_SUCCESS:
         const clinicsList = action.payload.data.clinics;
         const newTypeList = state.typeList.slice(0);
         const newZoneList = state.zoneList.slice(0);
         const newAreaList = state.areaList.slice(0);
         clinicsList.forEach(clinic => {
            const { t, ar, z } = clinic;
            if (newTypeList.indexOf(t) === -1) {
               newTypeList.push(t);
            }
            if (newZoneList.indexOf(z) === -1) {
               newZoneList.push(z);
            }
            if (newAreaList.indexOf(ar) === -1) {
               newAreaList.push(ar);
            }
         });
         return Object.assign({}, state, {
            data: action.payload.data.clinics,
            isLoaded: true,
            typeList: newTypeList,
            zoneList: newZoneList,
            areaList: newAreaList
         });
      case GET_CLINIC_LIST_ERROR:
         return Object.assign({}, state, {
            data: [],
            isLoaded: true,
            typeList: state.typeList.slice(0),
            zoneList: state.typeList.slice(0),
            areaList: state.typeList.slice(0),
            error: action.payload,
         });;
      default:
         return state;
   }
}
